var _desc, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaintenanceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 50 50",
    style: {
      fill: "var(--color--primary-text)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Icon of a wrench tool")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_453",
    "data-name": "Rectangle 453",
    width: 50,
    height: 4.5,
    transform: "translate(0 42)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "tools-wench-2",
    d: "M34.883,11.717a.748.748,0,0,0-.621-1.166H31.727a.748.748,0,0,1-.513-.2L28.832,8.1a.748.748,0,0,1,0-1.089l2.381-2.245a.748.748,0,0,1,.513-.2h2.535A.748.748,0,0,0,34.883,3.4a7.562,7.562,0,0,0-.931-1.133A7.482,7.482,0,0,0,21.341,9.122a.748.748,0,0,1-.2.687L7.357,23.591a.748.748,0,0,1-.572.217,5.986,5.986,0,1,0,5.63,5.634.748.748,0,0,1,.218-.57l13.8-13.795a.748.748,0,0,1,.685-.2,7.44,7.44,0,0,0,6.837-2.032,7.55,7.55,0,0,0,.931-1.125ZM8.027,31.365a2.245,2.245,0,1,1,0-3.174A2.245,2.245,0,0,1,8.027,31.365Z",
    transform: "translate(6 3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceIcon);
export default __webpack_public_path__ + "static/media/maintenance-icon.4393128409feac69c9ead20bab06f3f9.svg";
export { ForwardRef as ReactComponent };